import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7f18e3a6")

_pushScopeId("data-v-7f18e3a6")
const _hoisted_1 = {
  key: 0,
  class: "file-manager"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FileList = _resolveComponent("FileList")
  const _component_Card = _resolveComponent("Card")
  const _component_FileViewer = _resolveComponent("FileViewer")

  return (!_ctx.state.isLoading)
    ? (_openBlock(), _createBlock("section", _hoisted_1, [
        _createVNode("div", {
          class: !_ctx.state.isPX ? '' : '-content'
        }, [
          (!_ctx.state.isPX)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_Card, null, {
                  content: _withId(() => [
                    (!_ctx.state.isLoading)
                      ? (_openBlock(), _createBlock(_component_FileList, {
                          key: 0,
                          list: _ctx.state.list,
                          onOnSelectedRow: _ctx.onSelectedRow,
                          onDeletedFile: _ctx.deletedFile,
                          id: _ctx.key
                        }, null, 8, ["list", "onOnSelectedRow", "onDeletedFile", "id"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.select)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_component_Card, null, {
                  content: _withId(() => [
                    _createVNode(_component_FileViewer, {
                      select: _ctx.select,
                      isSidebar: true
                    }, null, 8, ["select"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]))
    : _createCommentVNode("", true)
})